import { useContext } from "react"
import { getCurrencySymbol } from "source/giving/utils/money"
import { ServerRenderedProps } from "source/shared/contexts/ServerRenderedProps"

export function CurrencyBadge() {
  const {
    current_organization: { currency },
  } = useContext(ServerRenderedProps)

  return (
    <div className="badge">
      <span className="visually-hidden">Currency:</span>
      {getCurrencySymbol(currency)} {currency.toUpperCase()}
    </div>
  )
}
